import { SearchParamsObject } from '@algolia/client-search';

import { searchAlgoliaOptionsFiltersForFacets } from 'modules/search/algolia/options/searchAlgoliaOptionsFiltersForFacets';
import { SearchJobsFilterKeys } from 'modules/search/constants/filters/searchJobsFilters';
import { searchFacetsJob } from 'modules/search/constants/searchFacetsJob';
import { SearchFiltersById } from 'modules/search/types/SearchFiltersById';
import { SearchLocation } from 'modules/search/types/SearchLocation';
import { algoliaQueryStringFilter } from 'utils/algolia/helpers/algoliaQueryStringFilter';
import { SEARCH_PAGE_SIZE } from 'utils/constants/general/searchPageSize';

export const jobAttributesToRetrieve = [
  'objectID',
  'type',
  'published',
  'name',
  'city',
  'state',
  'stateStr',
  'country',
  'url',
  'orgID',
  'orgUrl',
  'orgName',
  'orgType',
  'jobType',
  'logo',
  'locationType',
  'remoteZone',
  'paid',
  'payment',
  '_geoloc',
  'hasPublishedListings',
  'actionType',
  'source',
  'timezone',
  'hasAts',
  'isPostedAnonymously',
  'hiring',
  'salaryMinimum',
  'salaryMaximum',
  'salaryCurrency',
  'salaryPeriod',
  'earlyApplicant',
];

type Args = {
  facets?: SearchJobsFilterKeys[];
  filtersById: SearchFiltersById;
  searchLocation: SearchLocation | undefined;
};

export function searchAlgoliaJobsOptions({
  facets,
  filtersById,
  searchLocation,
}: Args): SearchParamsObject {
  return {
    facets: facets || ['*'],
    hitsPerPage: SEARCH_PAGE_SIZE,
    attributesToSnippet: ['description:20'],
    attributesToRetrieve: jobAttributesToRetrieve,
    filters: [
      algoliaQueryStringFilter('type', 'JOB'),
      ...searchAlgoliaOptionsFiltersForFacets({
        filtersById,
        searchFacets: searchFacetsJob,
        searchLocation,
      }),
    ].join(' AND '),
    removeStopWords: true,
    ignorePlurals: true,
    advancedSyntax: true,
    queryLanguages: ['en', 'es', 'pt'],
  } satisfies SearchParamsObject;
}
